import sizes from './sizes'
import colors from './colors'

export default {
  SP_LIGHT: {
    fontFamily: 'NunitoSans Light, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '300'
  },
  SP_REGULAR: {
    fontFamily: 'NunitoSans Regular, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '400'
  },
  SP_BOLD: {
    fontFamily: 'NunitoSans Bold, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '700'
  },
  SP_SEMIBOLD: {
    fontFamily: 'NunitoSans SemiBold, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '600'
  }
}
